import { customEmbedEvent, EventType } from '@embed/customEmbedEvent';
import { createLinkToEmbedVideoPage } from '@embed/helpers';
import { PostMessageSentinelEnum, postMessageWrapper, } from '@src/embeds/utils/postMessageWrapper';
import { ensureCachedVideoElement } from '@src/embeds/utils/videoElementWrapper';
/**
 *  Helping onClick events to unify thumbnail click
 *  behaviour (open in _self, _blank or open player)
 *
 *  @return {Boolean} `true` to let component handle its own player open mechanics
 *  @return {Boolean} `false` video opened by browser
 */
export const onNavigateToVideoHelper = ({ params, appContext, video, createVideoElement = true, }) => {
    var _a;
    try {
        params.onclick && params.onclick();
    }
    catch (error) {
        params.onerror && params.onerror(error);
    }
    customEmbedEvent({
        type: EventType.FW_EMBEDFEED_THUMBNAILCLICK,
        params,
        data: { video },
    });
    const isAmpFrame = params.location &&
        params.location.hash &&
        params.location.hash.search('amp=1') > -1;
    const { newLocation, serializableAppContext } = createLinkToEmbedVideoPage({
        appContext,
        params,
        video,
    });
    // Player is already running,
    // post message about new content
    if ((params.in_iframe && window.name === 'fw-iframe') ||
        document.getElementById('fw-player')) {
        postMessageWrapper({
            action: 'play',
            appContext: serializableAppContext,
            sentinel: PostMessageSentinelEnum.INTERNAL,
            video,
        });
        return false;
    }
    let openIn = !params.open_in || params.open_in === 'default' ? '_iframe' : params.open_in;
    let newWindow = null;
    // AMP iframe only allows blank and self
    // unless its in Cypress iframe
    if (!((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.version) &&
        !['_blank', '_self'].includes(openIn) &&
        (!params.open_in || params.open_in === 'default') &&
        (params.in_iframe || isAmpFrame)) {
        openIn = '_blank';
    }
    // Seems calling setting window.open
    // before await cools down popup blockers
    if (openIn === '_blank') {
        newWindow = window.open('', '_blank');
        if (newWindow) {
            newWindow.location = newLocation;
        }
        return false;
    }
    else if (openIn === '_self') {
        if (params.in_iframe || isAmpFrame) {
            newWindow = window.open('', '_top');
            if (newWindow) {
                newWindow.location = newLocation;
            }
        }
        else {
            window.location && (window.location.href = newLocation);
        }
        return false;
    }
    // Lets just create element for VideoPlayer
    // Doing so onClick helps us deliver umuted/autoplay
    if (createVideoElement) {
        ensureCachedVideoElement({
            key: 'videoplayer',
            autoplay: true,
            muted: false,
        });
    }
    return true;
};
